const axios = require('axios');
var SessionStorageManager = require('./SessionStorageManager');
var ApiClient = require('./ApiClient');
var numeral = require('numeral');

function Utils(){
    var self = this;

    self.storage = new SessionStorageManager();

    self.getApiClient = function(options){
        return new ApiClient(options);
    };

    self.formatPrice = function(number,precision){
        var format = '$0,0.00';
        if(precision == 0)
            format = '$0,0';
        if(typeof numeral != 'undefined')
            return numeral(number).format(format);
        else
            return '$'+number;
    };

    self.formatNumber= function(number,precision){
        var format = '0,0.00';
        if(precision == 0)
            format = '0,0';
        if(typeof numeral != 'undefined')
            return numeral(number).format(format);
        else
            return number;
    };

    self.formatPhoneNumber = function(phoneNumberString) {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            var intlCode = (match[1] ? '+1 ' : '')
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
        }
        return phoneNumberString;
    };

    self.alert = function(message,type,callback){
        if(typeof _alert == 'function')
            _alert(message,type,callback);
        else{
            alert(message);
            if(typeof callback == 'function')
                callback();
        }
    };

    self.confirm = function(message,callback,false_callback){
        if(typeof _confirm == 'function')
            _confirm(message,callback,false_callback);
        else{
            if(confirm(message))
                callback();
            else{
                if(typeof false_callback == 'function')
                    false_callback();
            }
        }
    };

    self.getUrlParameter = function(name,default_value) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        var variable = results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        if(variable == '' && default_value != null)
            variable = default_value;
        return variable;
    };

    self.stringToSlug = function(str){
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
        var to   = "aaaaeeeeiiiioooouuuunc------";
        for (var i=0, l=from.length ; i<l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes

        return str;
    };


    self.round = function(value,decimals){
        return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
    };

    self.extend = function(){
        for(var i=1; i<arguments.length; i++)
            for(var key in arguments[i])
                if(arguments[i].hasOwnProperty(key))
                    arguments[0][key] = arguments[i][key];
        return arguments[0];
    };

    self.toast = function(message,type){
        switch(type){
            case 'success':
                toastr.success(message);
                break;
            default:
                alert(message);
        }
    };

    self.decodeHTMLEntities = function(text) {
        console.log(text);
        var textArea = document.createElement('textarea');
        textArea.innerHTML = text;
        console.log(textArea.value);
        return textArea.value;
    };
}


module.exports = Utils;
